import { RichTextContent } from "../../../content/components";
import { isEmptySlateDocument } from "../../../core/constants";
import {
  AccommodationDetails,
  Configuration,
  Section,
} from "../../../resources/modelTypes";
import { DisplayPhoto } from "../DisplayPhoto";
import { SmallHeadline, ActionLink } from "@minted/fancyclothes";
import React, { memo } from "react";

export type DisplayAccommodationSectionProps = {
  configuration: Configuration;
  section: Section;
};

const DisplayAccommodationSection = ({
  configuration,
  section,
}: DisplayAccommodationSectionProps) => {
  const details = section.sectionDetails as AccommodationDetails;

  return (
    <>
      {(section.photo || section.image) && (
        <DisplayPhoto configuration={configuration} section={section} />
      )}
      <div data-cy="subheading">
        <SmallHeadline>{details.title}</SmallHeadline>
      </div>
      <div data-cy="body">
        {!isEmptySlateDocument(details.content) && (
          <div>
            <RichTextContent value={details.content} />
          </div>
        )}
      </div>
      {details.websiteUrl && (
        <div>
          <ActionLink
            target="_blank"
            text={details.anchorText || "Visit Website"}
            url={details.websiteUrl}
          />
        </div>
      )}
    </>
  );
};

const MemoizedDisplayAccommodationSection = memo(DisplayAccommodationSection);

export { MemoizedDisplayAccommodationSection as DisplayAccommodationSection };
